export default "__VITE_ASSET__BLHmYHaJ__"